import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"

import CompanyInfoContainer from "@/screens/Companies/edit/components/info/containers/CompanyInfoContainer"

export const Route: AnyRoute = createFileRoute("/app/companies/$companyId/edit/_layout/info")({
  component: CompanyInfoContainer,
})
